import { Component } from '@angular/core';


export class SkyDemoPhoneFormComponent { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-demo-phone-form',
  template: `<div class="sky-emphasized" style="margin-bottom: 5px;">
  <label>Home</label>
</div>
<div>303.997.3301</div>

<div class="sky-emphasized" style="margin: 5px 0 5px 0;">
  <label>Vacation</label>
</div>
<div>888.387.1211</div>

<div class="sky-emphasized" style="margin: 5px 0 5px 0;">
  <label>Vacation</label>
</div>
<div>303.997.2000</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
